import { render } from "./FournisseurPopup.vue?vue&type=template&id=89a3a4b4"
import script from "./FournisseurPopup.vue?vue&type=script&lang=js"
export * from "./FournisseurPopup.vue?vue&type=script&lang=js"

import "./FournisseurPopup.vue?vue&type=style&index=0&id=89a3a4b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__